const screenModuleBareSpecifier = "framer:screens"

export function screenImportSpecifierForName(name: string) {
    return `${screenModuleBareSpecifier}/${name}`
}
